import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import axios from "axios";
import severUrl from "../../api";

class Support extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: "",
        username: "",
      },
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ submitted: true });
    const { user } = this.state;
    if (user.username && user.password) {
      // this.props.register(user);
      // console.log(user);
      var bodyFormData = new FormData();
      bodyFormData.append("username", user.username);
      bodyFormData.append("password", user.password);
      axios
        .post(severUrl + "registration/login_user", bodyFormData)
        .then((response) => {
          // console.log(response.data);
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.reload();
          // console.log(response.json())
        });
    }
  }

  render() {
    const { registering } = this.props;
    const { user, submitted } = this.state;
    return (
      <>
  <p style={{margin:"60px"}}></p>
        <h4>
          If you need support, please don't hesitate send detail via email id:       </h4>
        <h3> htanloc994@gmail.com
        </h3>
      </>
    );
  }
}

function mapState(state) {
  const { registering } = state.registration;
  return { registering };
}

const actionCreators = {
  register: userActions.register,
};

const connectedRegisterPage = connect(mapState, actionCreators)(Support);
export { connectedRegisterPage as Support };
